export enum ReEngagementCTAMilestone {
	SUBMIT_TRANSCRIPTS = 'submit-transcripts',
	SUBMIT_APPLICATION = 'submit-application',
	TALK_TO_COUNSELOR = 'talk-to-counselor',
	UNDERSTAND_COSTS = 'understand-costs',
	COMPLETE_FAFSA = 'complete-fafsa',
	SCHEDULE_A_VISIT = 'schedule-a-visit',
	FINISH_ENROLLMENT = 'finish-enrollment',
	CONFIRM_ENROLLMENT = 'confirm-enrollment',
	ADMITTED = 'admitted',
	DEPOSIT = 'deposit',
	CSS_PROFILE = 'css-profile',
}

export const CTAMilestoneLabels: Record<ReEngagementCTAMilestone, string> = {
	[ReEngagementCTAMilestone.SUBMIT_TRANSCRIPTS]: 'Submit Transcripts',
	[ReEngagementCTAMilestone.SUBMIT_APPLICATION]: 'Submit Application',
	[ReEngagementCTAMilestone.TALK_TO_COUNSELOR]: 'Talk to Counselor',
	[ReEngagementCTAMilestone.UNDERSTAND_COSTS]: 'Understand Costs',
	[ReEngagementCTAMilestone.COMPLETE_FAFSA]: 'Complete FAFSA',
	[ReEngagementCTAMilestone.SCHEDULE_A_VISIT]: 'Schedule a Visit',
	[ReEngagementCTAMilestone.FINISH_ENROLLMENT]: 'Finish Enrollment',
	[ReEngagementCTAMilestone.CONFIRM_ENROLLMENT]: 'Confirm Enrollment',
	[ReEngagementCTAMilestone.ADMITTED]: 'Admitted',
	[ReEngagementCTAMilestone.DEPOSIT]: 'Deposit',
	[ReEngagementCTAMilestone.CSS_PROFILE]: 'Complete CSS Profile',
};

export enum MilestoneEntryTerm {
	FA2026 = 'FA2026',
	FA2027 = 'FA2027',
}

const ENTRY_TERM_SEASON_LABELS: Record<string, string> = {
	FA: 'Fall',
};

export const formatEntryTermLabel = (entryTerm: string): string => {
	const match = entryTerm.match(/^([A-Z]+)(\d{4})$/);
	if (!match) {
		return entryTerm;
	}
	const [, season, year] = match;
	return `${ENTRY_TERM_SEASON_LABELS[season] ?? season} ${year}`;
};

export const getCompletedMilestoneLabel = (value: string): string => {
	if (!value) return value;
	const parts = value.split('-');
	const entryTerm = parts.pop() ?? '';
	const milestone = parts.join('-');
	const milestoneLabel =
		CTAMilestoneLabels[milestone as ReEngagementCTAMilestone] ?? milestone;
	return `${milestoneLabel} - ${formatEntryTermLabel(entryTerm)}`;
};

export type CompletedMilestoneOption = {
	value: string;
	label: string;
};

export const getCompletedMilestoneOptions = (): CompletedMilestoneOption[] =>
	Object.values(MilestoneEntryTerm).flatMap((entryTerm) =>
		Object.values(ReEngagementCTAMilestone).map((milestone) => {
			const value = `${milestone}-${entryTerm}`;
			return {
				value,
				label: getCompletedMilestoneLabel(value),
			};
		}),
	);
